<template>
  <svg
    width="23"
    height="26"
    viewBox="0 0 23 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_40002730_3641"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="23"
      height="26"
    >
      <path
        d="M21.1397 26H1.86029C0.832882 26 0 25.1685 0 24.1429V1.85714C0 0.831472 0.832882 0 1.86029 0H14.375L23 8.61039V24.1429C23 25.1685 22.1671 26 21.1397 26Z"
        fill="url(#paint0_linear_40002730_3641)"
      />
    </mask>
    <g mask="url(#mask0_40002730_3641)">
      <path
        d="M21.1397 26H1.86029C0.832882 26 0 25.1685 0 24.1429V1.85714C0 0.831472 0.832882 0 1.86029 0H14.375L23 8.61039V24.1429C23 25.1685 22.1671 26 21.1397 26Z"
        fill="url(#paint1_linear_40002730_3641)"
      />
      <path
        d="M4.36472 15.3202H6.30872C6.63405 15.3202 6.93805 15.3522 7.22072 15.4162C7.50339 15.4749 7.74872 15.5762 7.95672 15.7202C8.16472 15.8642 8.32739 16.0562 8.44472 16.2962C8.56739 16.5309 8.62872 16.8242 8.62872 17.1762C8.62872 17.5122 8.56739 17.8056 8.44472 18.0562C8.32739 18.3016 8.16472 18.5042 7.95672 18.6642C7.75405 18.8242 7.51405 18.9442 7.23672 19.0242C6.95939 19.0989 6.66072 19.1362 6.34072 19.1362H5.54872V21.2402H4.36472V15.3202ZM6.26072 18.2002C7.06605 18.2002 7.46872 17.8589 7.46872 17.1762C7.46872 16.8296 7.36205 16.5896 7.14872 16.4562C6.94072 16.3229 6.63139 16.2562 6.22072 16.2562H5.54872V18.2002H6.26072ZM9.70066 15.3202H11.3247C11.778 15.3202 12.1833 15.3789 12.5407 15.4962C12.9033 15.6136 13.21 15.7949 13.4607 16.0402C13.7167 16.2802 13.9113 16.5842 14.0447 16.9522C14.1833 17.3202 14.2527 17.7549 14.2527 18.2562C14.2527 18.7522 14.1833 19.1869 14.0447 19.5602C13.9113 19.9336 13.7193 20.2456 13.4687 20.4962C13.2233 20.7416 12.9247 20.9282 12.5727 21.0562C12.2207 21.1789 11.826 21.2402 11.3887 21.2402H9.70066V15.3202ZM11.2527 20.2882C11.53 20.2882 11.778 20.2509 11.9967 20.1762C12.2207 20.0962 12.41 19.9762 12.5647 19.8162C12.7193 19.6509 12.8367 19.4402 12.9167 19.1842C13.002 18.9282 13.0447 18.6189 13.0447 18.2562C13.0447 17.8936 13.002 17.5869 12.9167 17.3362C12.8367 17.0802 12.7193 16.8749 12.5647 16.7202C12.41 16.5602 12.2207 16.4456 11.9967 16.3762C11.778 16.3016 11.53 16.2642 11.2527 16.2642H10.8847V20.2882H11.2527ZM15.4116 15.3202H19.0596V16.3042H16.5956V17.8482H18.6996V18.8402H16.5956V21.2402H15.4116V15.3202Z"
        fill="white"
      />
      <g filter="url(#filter0_d_40002730_3641)">
        <path
          d="M23 8.61039H16.375C15.2704 8.61039 14.375 7.71496 14.375 6.61039V0L23 8.61039Z"
          fill="url(#paint2_linear_40002730_3641)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_40002730_3641"
        x="-8.625"
        y="-24"
        width="58.625"
        height="58.6104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="2"
          dy="1"
        />
        <feGaussianBlur stdDeviation="12.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_40002730_3641"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_40002730_3641"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_40002730_3641"
        x1="11.5"
        y1="0"
        x2="11.5"
        y2="26"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF7979" />
        <stop
          offset="1"
          stop-color="#E85555"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_40002730_3641"
        x1="11.5"
        y1="0"
        x2="11.5"
        y2="26"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF7981" />
        <stop
          offset="1"
          stop-color="#E85567"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_40002730_3641"
        x1="18.6875"
        y1="0"
        x2="18.6875"
        y2="8.61039"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D03954" />
        <stop
          offset="1"
          stop-color="#C02A3C"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
